export const layoutDNDTypes = {
  TEMPLATE_FIELD: 'field',
};
